module.exports = __webpack_public_path__ + "3e3bab1441000ff7e5e5b1b4e633b2db.png";